import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7010d934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps-content" }
const _hoisted_2 = { class: "steps-action" }

import { onMounted, ref, UnwrapRef} from 'vue';
import { message } from 'ant-design-vue';
import { reactive } from 'vue'
import SelectTreat from "@/views/process/common/selectTreat.vue";
import SelectOralOrder from "@/views/process/common/selectOralOrder.vue";
import SelectClinicAndDentist from "@/views/process/common/selectClinicAndDentist.vue";
import SetAmount from "@/views/process/common/setAmount.vue";
import {useRoute, useRouter} from "vue-router";
import {finishTask} from "@/api/home";
import {deleteInstance} from "@/api/instance";
// import { useRoute, useRouter } from "vue-router";

interface Data {
    current: number,
    steps: any[],
    loading: boolean,
    params:{
        relatedType: string|undefined,
        relatedId: string,
        relatedName: string,
        treatId: string,
        orderId: string,
        dentistId: string,
        clinicId: string,
        amount: string,
        preloadAmount: string,
        paySubject: string
    },
    paramsOther:{
        treatName: string,
        orderName: string,
        dentistName: string,
        clinicName: string,
    }
}

export default /*#__PURE__*/_defineComponent({
  __name: 't901',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const data: UnwrapRef<Data> = reactive({
    current: 1,
    loading:false,
    steps: [
        // {
        //     title: '客户选择',
        //     target: SelectPatientOrLead
        // },
        {
            title: '治疗项目选择',
            target: SelectTreat
        },
        {
            title: '口腔订单选择',
            target: SelectOralOrder
        },
        {
            title: '门诊和医生选择',
            target: SelectClinicAndDentist
        },
        {
            title: '设定支付金额',
            target: SetAmount
        },
    ],
    params:{
        relatedType: "",
        relatedId: "",
        relatedName: "",
        treatId: "",
        orderId: "",
        amount: "",
        preloadAmount: "",
        dentistId: "",
        clinicId: "",
        paySubject: "",
    },
    paramsOther:{
        treatName: "",
        orderName: "",
        dentistName: "",
        clinicName: "",
    }
})

onMounted(()=>{
    console.log(route.query);
    
    data.params.relatedId = route.query.relatedId as string
    // data.params.relatedName = res.name;
    data.params.relatedType = route.query.relatedType as string;
})
/**
 * type类型：
 * 0：线索
 * 1：病人
 * 2：治疗项
 * 3：拍摄订单
 * 4：医生团队
 * 5：门诊
 * 6：付款金额
 * 7：预计付款金额
 * @param res
 */
const selectChange = (res: {type:number|undefined,id:string,name: string,amount: string}) => {
    switch (res.type) {
        case 0:
        case 1:
        case 2:
            data.params.treatId = res.id;
            data.paramsOther.treatName = res.name;
            break;
        case 3:
            data.params.orderId = res.id
            data.paramsOther.orderName = res.name;
            break;
        case 4:
            data.params.dentistId = res.id
            data.paramsOther.dentistName = res.name;
            break;
        case 5:
            data.params.clinicId = res.id
            data.paramsOther.clinicName = res.name;
            break;
        case 6:
            data.params.amount = res.amount
            break;
        case 7:
            data.params.preloadAmount = res.amount
            break;
        case 8:
            data.params.paySubject = res.name
            break;
    }

}

const current = ref<number>(0);
const next = () => {
    // if(current.value === 0 && !data.params.relatedId){
    //     message.warn("请先选择线索/病人")
    //     return;
    // }
    if(current.value === 1 && (!data.params.treatId)){
        message.warn("请先选择治疗项")
        return;
    }
    // if(current.value === 2 && !data.params.orderId){
    //     message.warn("请先选择诊断订单")
    //     return;
    // }
    if(current.value === 3 && (!data.params.dentistId || !data.params.clinicId)){
        message.warn("请选择医生/门诊信息")
        return;
    }
    current.value++;
};
const prev = () => {
    current.value--;
};
const toNext = async() => {
    console.log(data.params)
    if(!data.params.paySubject){
        message.warning("请选择付款方");
        return;
    }
    if(!data.params.preloadAmount || Number.parseFloat(data.params.preloadAmount) <= 0){
        message.warning("预计价格应当大于0");
        return;
    }
    if(!data.params.amount || Number.parseFloat(data.params.amount) <= 0){
        message.warning("接单费应当大于0");
        return;
    }
    data.loading = true
    let processDefinitionId = route.query.processDefinitionId;
    let processInstanceId = route.query.processInstanceId;
    let processDefinitionKey = route.query.processDefinitionKey;
    let runTimeTaskId = route.query.runTimeTaskId;
    let taskCode = route.query.taskCode;
    let parameters = {
        processDefinitionId,
        processInstanceId,
        processDefinitionKey,
        runTimeTaskId,
        taskCode,
        params: data.params
    }
    finishTask(parameters).then(() => {
        message.success("操作成功");
        data.loading = false
        router.push({
            path: "/home",
        });
    }).catch(()=>{
        data.loading = false
    });
};

const cancelInstance = ()=>{
    let processInstanceId = route.query.processInstanceId;
    deleteInstance({instanceId:processInstanceId}).then(()=>{
        router.push({ path: '/home' })
    })
}

return (_ctx: any,_cache: any) => {
  const _component_check_circle_filled = _resolveComponent("check-circle-filled")!
  const _component_clock_circle_filled = _resolveComponent("clock-circle-filled")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          title: "完成度",
          layout: "vertical",
          bordered: "",
          column: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "治疗项目" }, {
              default: _withCtx(() => [
                (data.params.treatId)
                  ? (_openBlock(), _createBlock(_component_check_circle_filled, {
                      key: 0,
                      style: {"color":"#42b983"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.paramsOther.treatName), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_clock_circle_filled, {
                      key: 1,
                      style: {"color":"#99344d"}
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "订单" }, {
              default: _withCtx(() => [
                (data.params.orderId)
                  ? (_openBlock(), _createBlock(_component_check_circle_filled, {
                      key: 0,
                      style: {"color":"#42b983"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.paramsOther.orderName), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_clock_circle_filled, {
                      key: 1,
                      style: {"color":"#99344d"}
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, {
              span: 1,
              label: "医生负责人"
            }, {
              default: _withCtx(() => [
                (data.params.dentistId)
                  ? (_openBlock(), _createBlock(_component_check_circle_filled, {
                      key: 0,
                      style: {"color":"#42b983"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.paramsOther.dentistName), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_clock_circle_filled, {
                      key: 1,
                      style: {"color":"#99344d"}
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, {
              span: 1,
              label: "门诊负责人"
            }, {
              default: _withCtx(() => [
                (data.params.clinicId)
                  ? (_openBlock(), _createBlock(_component_check_circle_filled, {
                      key: 0,
                      style: {"color":"#42b983"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.paramsOther.clinicName), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_clock_circle_filled, {
                      key: 1,
                      style: {"color":"#99344d"}
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, {
              span: 1,
              label: "付款金额"
            }, {
              default: _withCtx(() => [
                (data.params.amount)
                  ? (_openBlock(), _createBlock(_component_check_circle_filled, {
                      key: 0,
                      style: {"color":"#42b983"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.params.amount), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_clock_circle_filled, {
                      key: 1,
                      style: {"color":"#99344d"}
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, {
      title: "初始化销售流程",
      bordered: false,
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_steps, {
          current: current.value,
          "progress-dot": ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.steps, (item) => {
              return (_openBlock(), _createBlock(_component_a_step, {
                key: item.title,
                title: item.title
              }, null, 8, ["title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["current"]),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_KeepAlive, { exclude: "SelectTreat,SelectOralOrder" }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(data.steps[current.value].target), {
              onSelectChange: selectChange,
              "order-id": data.params.orderId,
              "patient-id": data.params.relatedId,
              "related-id": data.params.relatedId,
              "treat-id": data.params.treatId
            }, null, 40, ["order-id", "patient-id", "related-id", "treat-id"]))
          ], 1024))
        ]),
        _createElementVNode("div", _hoisted_2, [
          (current.value > 0)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                style: {"margin-right":"8px"},
                onClick: prev
              }, {
                default: _withCtx(() => [
                  _createTextVNode("上一步")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (current.value < data.steps.length - 1)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "primary",
                onClick: next
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下一步")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (current.value == data.steps.length - 1)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                type: "primary",
                loading: data.loading,
                onClick: toNext
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 发送至下一步 ")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_button, {
            style: {"margin-left":"8px"},
            onClick: cancelInstance
          }, {
            default: _withCtx(() => [
              _createTextVNode("结束流程")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})